const QrCode = require('html5-qrcode');

var BarcodeDecoder = {
  registerDecoder: function ($renderElement, $input, $previewElement) {
    $input.on('change', function () {
      image = this.files[0];
      const html5QrcodeScanner = new QrCode.Html5Qrcode(
        $renderElement.attr('id'),
        {},
      );

      html5QrcodeScanner.scanFile(image, false).then((text) => {
        $previewElement.val(text);
      });
    });
  },
};

module.exports = BarcodeDecoder;
window.BarcodeDecoder = BarcodeDecoder;
